// Import Core
import React, { useCallback, useEffect, useState } from "react";
import { graphql } from "gatsby";
import styled from "styled-components";
import axios from "axios";
// Import Components
import Seo from "../../../components/Seo";
import SinglePageFlexibleContent from "../../../components/blocks/SinglePageFlexibleContent";
import SingleProductHero from "../../../components/blocks/hero/SingleProductHero";
import StickyCta from "../../../components/blocks/ctas/StickyCta";
import FloatingButton from "../../../components/ui/buttons/FloatingButton";
import MapMultipleLocations from "../../../components/blocks/MapMultipleLocations";
import CardListSimple from "../../../components/blocks/CardListSimple";
import CardListShortBreaks from "../../../components/blocks/CardListShortBreaks";
import AnchorMenu from "../../../components/blocks/AnchorMenu";
import SimpleContent from "../../../components/blocks/SimpleContent";
import Separator from "../../../components/ui/Separator";
import IconList from "../../../components/ui/IconList";
import ClientTestimonials from "../../../components/blocks/ClientTestimonials";
// Import Utils
import useMap from "../../../utils/useMap";
import { productFeaturesListItems } from "../../../utils/productFeaturesListItems";
import ProductSpecialOffers from "../../../components/blocks/ProductSpecialOffers";
import { getShortDate } from "../../../utils/datetime/getShortDate";
import { randomExpertInPriority } from "../../../utils/randomExpertInPriority";
import { usePushToDataLayer } from "../../../utils/getPageSanityId";
// Import configData
import configData from "../../../../configData.json";

const SingleProductStyling = styled.div``;

// Define component
const TailorMadeHolidayPage = ({ data, location }) => {
  const page = data.tailorMadeHoliday;
  const price = page?.priceFrom?.match(/£([\d,]+)/)?.[1] || "NoPrice";
  usePushToDataLayer(price, "tailormade", page?._id, "travel");

  const city =
    page.includedCities && page.includedCities.length > 0
      ? `${page.includedCities[0].name}, `
      : "";
  // const country = page.includedCountries[0].name;
  const country =
    page.includedCountries && page.includedCountries.length > 0
      ? `${page.includedCountries[0].name}`
      : "";

  // Get the final expert collections in priority order
  const expertDetail = randomExpertInPriority(
    page?.includedCities[0]?.expertCollection,
    page?.includedRegions[0]?.expertCollection,
    page?.includedCountries[0]?.expertCollection
  );

  const [anchorLinks, setAnchorLinks] = useState([]);
  // SetIsPageLoaded on every render to ensure that if AnchorMenu is true it will render all items
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  useEffect(() => {
    setIsPageLoaded(true);
  });

  // FOLLOW UP: NOT ALL Tailor made have cities so no map for now - also removed $pageLocationId from gatsby-node for graphql
  // // If we have cities, filter out ones with coordinates to show on the map
  // const [mapSelection, setMapSelection] = useState();

  // Set Darwin Data
  const [darwin, setDarwin] = useState(null);
  const [darwinDates, setDarwindates] = useState("");
  const [lowestPrice, setLowestPrice] = useState("");
  const [datedDarwin, setdatedDarwin] = useState([]);
  const [darwinDateId, setdarwinDateId] = useState([]);
  const darwinId = page.darwinId;
  const priceFrom = page.priceFrom;
  const siteURL = location.origin;
  const gatsbyDarwin = `${siteURL}/api/getitinerarydetails/${darwinId}`;

  useEffect(() => {
    const url = gatsbyDarwin;
    axios
      .get(url)
      .then((response) => {
        setDarwin(response.data);
      })
      .catch((error) => {
        console.log({ error });
      });
  }, []);

  const populatedData =
    darwin && darwin.ItineraryList.dated[0]
      ? darwin.ItineraryList.dated[0]
      : darwin && darwin.ItineraryList.nondated[0]
      ? darwin.ItineraryList.nondated[0]
      : null;

  const fromPrice =
    populatedData && populatedData.pricefrom
      ? populatedData.pricefrom
      : "Price on Request";
  const duration =
    populatedData && populatedData.duration ? populatedData.duration : "tbc";
  const dates =
    populatedData && populatedData.departuredates
      ? populatedData.departuredates
      : null;

  let fromPriceText;
  if (fromPrice === "Price on Request") {
    fromPriceText = "Price on request.";
  } else {
    fromPriceText = "From £" + { fromPrice } + " per person.";
  }

  let durationText;
  if (duration === "tbc") {
    durationText = "";
  } else {
    durationText = "From " + duration + " nights. ";
  }

  const priceText = (
    <p>{`This is a guide price based on two sharing; prices may vary depending on seasonal hotel and flight costs. We would be delighted to amend this suggested itinerary – perhaps stay longer in one location, select different hotels, or extend the holiday to include another destination. Our experienced team is ready to discuss your requirements.`}</p>
  );

  useEffect(() => {
    if (dates) {
      const todayDate = new Date();
      const filteredTours = dates.filter((tour) => {
        const tourDepartureDate = new Date(tour.landonlydeparturedate);
        return tourDepartureDate > todayDate;
      });

      let lowestPriceTour = filteredTours[0]; // Assume the first tour has the lowest price

      for (let i = 1; i < filteredTours.length; i++) {
        if (
          filteredTours[i].landonlyadultprice <
          lowestPriceTour.landonlyadultprice
        ) {
          lowestPriceTour = filteredTours[i];
        }
      }

      setLowestPrice(lowestPriceTour.landonlyadultprice);

      const arrDates = [];

      filteredTours.forEach((date) => {
        const shortDate = getShortDate(date.landonlydeparturedate);
        const displayDate = shortDate.slice(0, -5);
        arrDates.push(displayDate);
      });

      const strDates = arrDates.join(", ");
      setDarwindates(strDates);

      setdatedDarwin(
        filteredTours.map((date) => {
          return [
            getShortDate(date.landonlydeparturedate),
            date.seatsavailable >= 1 ? "Available" : "Closed",
            `£${date.landonlyadultprice}`,
            "On Request",
            { slug: configData.enquiry.enquiry.link },
          ];
        })
      );

      setdarwinDateId(
        filteredTours.map((date) => {
          return date.darwindateid;
        })
      );
    }
  }, []);

  // useEffect(() => {
  // 	if (data.cities) {
  // 		setMapSelection(
  // 			data.cities.nodes.filter((city) => city.location && city.location.lat)
  // 		);
  // 	}
  // }, [data]);

  console.log("data", data);

  return (
    <SingleProductStyling className="single-product-page">
      <SingleProductHero
        title={page.title}
        tagline="Tailor-made Holidays"
        image={
          page.heroImage && page.heroImage.asset ? page.heroImage.asset : null
        }
        caption={
          page.heroImage && page.heroImage.asset && page.heroImage.asset.title
            ? page.heroImage.asset.title
            : ""
        }
        subheading={`${city}${country}`}
        // price={priceFrom ? priceFrom : lowestPrice ? lowestPrice : fromPrice}
        price={priceFrom ? priceFrom : fromPrice}
        duration={priceFrom ? "" : duration}
      />

      {isPageLoaded && (
        <AnchorMenu
          anchorLinks={anchorLinks}
          setAnchorLinks={setAnchorLinks}
          location={location}
        />
      )}

      <div className="single-product-content">
        <div className="product-main">
          <div className="product-content">
            {page.mainContent && (
              <SimpleContent
                content={page.mainContent}
                addToAnchor={true}
                anchorTitle="Overview"
              />
            )}

            {page.includedHotel && page.includedHotel.length > 0 && (
              <CardListShortBreaks
                addToAnchor={true}
                title="Hotel Details"
                cardList={page.includedHotel}
              />
            )}

            {page.includes.length > 0 && <Separator color="grey-thin" />}

            {page.includes.length > 0 && (
              <div
                className={`product-features ${page.isLink && "anchor-link"}`}
                id={page.isLink ? "anchor_whats-included" : ""}
              >
                <h3>{`What's included`}</h3>
                <IconList
                  iconListItems={productFeaturesListItems(page.includes)}
                  iconLayout="minimal"
                  showDescriptions={true}
                />
              </div>
            )}

            {page.singlePageContent &&
              page.singlePageContent.singlePageContent &&
              page.singlePageContent.singlePageContent.length > 0 && (
                <Separator color="grey-thin" />
              )}

            {page.singlePageContent &&
              page.singlePageContent.singlePageContent &&
              page.singlePageContent.singlePageContent.length > 0 && (
                <SinglePageFlexibleContent
                  pageContent={page.singlePageContent.singlePageContent}
                />
              )}

            {data.specialOffers.nodes &&
              data.specialOffers.nodes.length > 0 && (
                <Separator color="grey-thin" />
              )}

            {data.specialOffers.nodes &&
              data.specialOffers.nodes.length > 0 && (
                <ProductSpecialOffers
                  specialOffers={data.specialOffers.nodes}
                />
              )}

            {duration && fromPrice && <Separator color="grey-thin" />}

            {/* Removed to pull priceFrom Data */}
            {/* {(duration && fromPrice) && (
							<div className="product-pricing">
								<h3>PRICING</h3>
								<p className="blue medium bold">{durationText}{fromPriceText}</p>
								{priceText}
							</div>
						)} */}

            {priceFrom && (
              <div className="product-pricing">
                <h3>PRICING</h3>
                <p className="blue medium bold">{priceFrom}</p>
                {priceText}
              </div>
            )}
          </div>

          {/* STICKY CTA WITH COUNTRY EXPERT */}
          {expertDetail && (
            <StickyCta
              country={country}
              expert={expertDetail}
              pageType="product"
              productTitle={page.title}
              productDarwinId={page.darwinId}
            />
          )}
        </div>
      </div>

      <Separator color="grey-thick" />

      {page.additionalSinglePageContent &&
        page.additionalSinglePageContent.singlePageContent &&
        page.additionalSinglePageContent.singlePageContent.length > 0 && (
          <SinglePageFlexibleContent
            pageContent={page.additionalSinglePageContent.singlePageContent}
          />
        )}

      {/* {(page.location && page.location.lat && data.cities && data.cities.nodes.length > 0) && (
				<Separator color="grey-thin" />
			)} */}
      {/* TODO: CAN THIS BE MADE GLOBAL COMPONENT OR NO? */}
      {/* FOLLOW UP:  Map currently removed until new direction given as not all TailorMade has an assigned country / city ... */}
      {/* {(page.location &&	page.location.lat && data.cities && data.cities.nodes.length > 0) && (
					<MapSlideIn
						className='explore'
						mapSelection={mapSelection}
						allLocations={data.cities.nodes}
						tagline="City"
					/>
				)} */}

      {data.testimonials?.nodes?.length > 0 && (
        <ClientTestimonials
          addToAnchor={true}
          testimonials={data.testimonials.nodes}
        />
      )}
    </SingleProductStyling>
  );
};

// Attach SEO
export const Head = ({ data }) => {
  const page = data.tailorMadeHoliday;
  return (
    <Seo
      title={
        page.seoGroup && page.seoGroup.seoMetaTitle
          ? page.seoGroup.seoMetaTitle
          : `${page.name} - Kirker Holidays - Tailor-Made Holiday`
      }
      description={
        page.seoGroup &&
        page.seoGroup.seoMetaDescription &&
        page.seoGroup.seoMetaDescription
      }
      key={page._id}
    />
  );
};

// Export component
export default TailorMadeHolidayPage;

// Add page query
export const query = graphql`
  # FOLLOW UP: Map - , $pageLocationId: [String]!
  query ($slug: String!, $pageId: String!, $slugRegex: String!) {
    tailorMadeHoliday: sanityTailorMadeHoliday(
      slug: { current: { eq: $slug } }
    ) {
      _id
      _type
      title
      slug {
        current
      }
      darwinId
      priceFrom
      addAnchor
      enabled
      isLink
      # thumbnail {
      # 	asset {
      # 		gatsbyImageData(width: 400, placeholder: BLURRED)
      # 	}
      # }
      heroImage {
        asset {
          gatsbyImageData(placeholder: BLURRED)
          title
        }
      }
      mainContent: _rawMainContent(resolveReferences: { maxDepth: 10 })

      includes {
        name
        description
        icon {
          _type
          name
          provider
          svg
        }
      }
      location {
        alt
        lat
        lng
      }
      includedHotel {
        _id
        _type
        title
        image: thumbnail {
          asset {
            gatsbyImageData
          }
        }
        content: excerpt
        starRating
        hotelType
        slug {
          current
        }
        city {
          name
        }
        region {
          name
        }
        country {
          _id
          _type
          name
          slug {
            current
          }
          isInEurope
        }
      }

      includedCities {
        _id
        _type
        name
        slug {
          current
        }
        country {
          _id
          _type
          slug {
            current
          }
          isInEurope
        }
        expertCollection {
          _id
          _type
          title
          jobTitle
          email
          thumbnail {
            asset {
              gatsbyImageData(width: 80, height: 80, placeholder: BLURRED)
            }
          }
          slug {
            current
          }
        }
      }
      includedRegions {
        _id
        _type
        name
        slug {
          current
        }
        country {
          _id
          _type
          slug {
            current
          }
          isInEurope
        }
        expertCollection {
          _id
          _type
          title
          jobTitle
          email
          thumbnail {
            asset {
              gatsbyImageData(width: 80, height: 80, placeholder: BLURRED)
            }
          }
          slug {
            current
          }
        }
      }
      includedCountries {
        _id
        _type
        name
        slug {
          current
        }
        isInEurope
        expertCollection {
          _id
          _type
          title
          jobTitle
          email
          thumbnail {
            asset {
              gatsbyImageData(width: 80, height: 80, placeholder: BLURRED)
            }
          }
          slug {
            current
          }
        }
      }

      # Flexible Content
      singlePageContent {
        ...SanitySinglePageContentFragment
      }
      additionalSinglePageContent {
        ...SanityAdditionalSinglePageContentFragment
      }
      seoGroup {
        seoMetaTitle
        seoMetaDescription
      }
    }
    # FOLLOW UP: Map
    # cities: allSanityCityPage(
    # 	filter: { country: { _id: { in: $pageLocationId } } }
    # ) {
    # 	nodes {
    # 		_id
    # 		_type
    # 		name
    # 		image: thumbnail {
    # 			asset {
    # 				gatsbyImageData(width: 100, height: 100, placeholder: BLURRED)
    # 			}
    # 		}
    # 		slug {
    # 			current
    # 		}
    # 		country {
    # 			_id
    # 			_type
    # 			name
    # 			slug {
    # 				current
    # 			}
    # 			isInEurope
    # 		}
    # 		location {
    # 			lat
    # 			lng
    # 		}
    # 	}
    # }
    specialOffers: allSanitySpecialOffer(
      filter: {
        assignedCptType: { eq: "tailorMadeHoliday" }
        assignedCptTailorMadeHoliday: { _id: { eq: $pageId } }
        enabled: { eq: true }
      }
    ) {
      nodes {
        _id
        _type
        title
        excerpt
        assignedCptType
      }
    }

    testimonials: allSanityTestimonial(
      filter: {
        enabled: { eq: true }
        slug: { current: { regex: $slugRegex } }
      }
    ) {
      nodes {
        id
        excerpt
        isGeneric
        _rawMainContent
        # publishedDate(formatString: "DD MMM YYYY")
        author
      }
    }
  }
`;
